<template>
  <div>
    <VueSlickCarousel
      ref="navSlick"
      :arrows="true"
      :dots="true"
      class="group/slick instance-slider-slick"
      v-bind="sliderSettings"
      @beforeChange="syncSliders"
    >
      <!-- Блок с картинкой -->

      <template v-for="(block, index) in blocks">
        <div
          v-if="block.type === 'media'"
          :key="index"
          class="group/slide pointer-events-all relative"
          :class="{
            'h-90': sidebar.size == 1 || $windowSize.isMobile,
            'h-110': sidebar.size == 2 && !$windowSize.isMobile,
            'h-120': sidebar.size == 3 && !$windowSize.isMobile,
          }"
          @click="
            () => {
              if (!$windowSize.isDesktop) {
                openModal(block);
              }
            }
          "
        >
          <slot v-if="index == 0" name="first-slide"> </slot>
          <button
            v-if="!isSidebarModalOpen && $windowSize.isDesktop"
            class="z-2 group-has-[.loaded]/slide:flex size-12 shadow-around hover:bg-primary hover:text-onPrimary backdrop-blur-xs absolute left-[calc(50%-6*var(--spacing))] top-[calc(50%-6*var(--spacing))] hidden cursor-pointer items-center justify-center rounded-xl bg-white/70 text-neutral-800 opacity-0 transition-[color,background-color,opacity] group-hover/slide:opacity-100 dark:bg-neutral-800/70 dark:text-neutral-100"
            @click="openModal(block)"
          >
            <lucide-icon icon="Maximize" class="" :size="20"></lucide-icon>
          </button>
          <LazyImage
            :url="block.data.preview_url"
            class="z-1 pointer-events-none h-full"
            image-class="max-h-full"
          />
        </div>
        <!-- Блок с интерактивным контентом -->
        <div
          v-if="block.type === 'interactive'"
          :key="index"
          class="group/slide relative"
          :class="{
            'h-90': sidebar.size == 1,
            'h-110': sidebar.size == 2,
            'h-120': sidebar.size == 3,
          }"
          @click="
            () => {
              if (!$windowSize.isDesktop) {
                // openInteractive(block.data.props);
              }
            }
          "
        >
          <router-link
            v-if="$windowSize.isDesktop"
            :to="
              getRouterConfig({
                name: 'Interactive',
                params: {
                  interactiveId: block.data.props.id,
                  frameId: block.data.props.frame_id,
                  storeyId: block.data.props.storey_id,
                },
              })
            "
            class="z-2 size-12 shadow-around hover:bg-primary hover:text-onPrimary backdrop-blur-xs absolute left-[calc(50%-6*var(--spacing))] top-[calc(50%-6*var(--spacing))] flex cursor-pointer items-center justify-center rounded-xl bg-white/70 text-neutral-800 opacity-0 transition-[color,background-color,opacity] group-hover/slide:opacity-100 dark:bg-neutral-800/70 dark:text-neutral-100"
          >
            <lucide-icon icon="Interactive" :size="20"></lucide-icon>
          </router-link>
          <!-- {{ block.data.interactive }} -->
          <InteractiveStatic
            v-if="block.data.interactive"
            :key="`sidebar-resizer-${sidebar.size}-${sidebar.offset}`"
            class="pointer-events-none h-full"
            :interactive="block.data.interactive"
          />
        </div>
      </template>

      <template #prevArrow>
        <button
          class="z-3 size-8 md:group-hover/slick:not-[.slick-disabled]:shadow-around md:group-hover/slick:not-[.slick-disabled]:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:bg-white/70 dark:md:group-hover/slick:not-[.slick-disabled]:bg-neutral-900/90 not-[.slick-disabled]:cursor-pointer max-md:shadow-around max-md:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:opacity-100 dark:not-[.slick-disabled]:text-neutral-300 hover:!bg-primary hover:!text-onPrimary [.slick-disabled]:opacity-30 [.slick-disabled]:pointer-events-none absolute left-2 top-[calc(50%-4*var(--spacing))] flex items-center justify-center rounded-lg text-neutral-800 transition-[color,background-color,opacity] max-md:bg-white/70 max-md:opacity-100 dark:max-md:bg-neutral-800/70 md:opacity-60"
        >
          <lucide-icon icon="ChevronLeft" :size="22" />
        </button>
      </template>
      <template #nextArrow>
        <button
          class="z-3 size-8 md:group-hover/slick:not-[.slick-disabled]:shadow-around md:group-hover/slick:not-[.slick-disabled]:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:bg-white/70 dark:md:group-hover/slick:not-[.slick-disabled]:bg-neutral-900/90 not-[.slick-disabled]:cursor-pointer max-md:shadow-around max-md:backdrop-blur-xs md:group-hover/slick:not-[.slick-disabled]:opacity-100 dark:not-[.slick-disabled]:text-neutral-300 hover:!bg-primary hover:!text-onPrimary [.slick-disabled]:opacity-30 [.slick-disabled]:pointer-events-none absolute right-2 top-[calc(50%-4*var(--spacing))] flex items-center justify-center rounded-lg text-neutral-800 transition-[color,background-color,opacity] max-md:bg-white/70 max-md:opacity-100 dark:max-md:bg-neutral-800/70 md:opacity-60"
        >
          <lucide-icon icon="ChevronRight" :size="22" />
        </button>
      </template>

      <!-- <template #prevArrow>
        <div
          class="group/arrow not-[.slick-disabled]:cursor-pointer not-[.slick-disabled]:hover:after:opacity-100 after:bg-linear-to-r not-[.slick-disabled]:hover:text-primary dark:not-[.slick-disabled]:hover:text-neutral-100 [.slick-disabled]:opacity-30 z-2 absolute left-0 right-auto top-0 flex h-[calc(100%-4*var(--spacing))] w-20 items-center justify-start ps-2 text-neutral-700 opacity-30 transition-colors transition-opacity after:pointer-events-none after:absolute after:left-0 after:top-0 after:z-0 after:h-full after:w-20 after:from-white after:from-15% after:to-white/0 after:to-100% after:opacity-0 after:transition-opacity group-hover/slick:opacity-100 dark:after:from-neutral-900/60 dark:after:to-neutral-800/0"
        >
          <lucide-icon class="z-1" icon="ChevronLeft" :size="22" />
        </div>
      </template>
      <template #nextArrow>
        <div
          class="group/arrow not-[.slick-disabled]:cursor-pointer not-[.slick-disabled]:hover:after:opacity-100 after:bg-linear-to-l not-[.slick-disabled]:hover:text-primary dark:not-[.slick-disabled]:hover:text-neutral-100 [.slick-disabled]:opacity-30 z-2 absolute left-auto right-0 top-0 flex h-[calc(100%-4*var(--spacing))] w-20 items-center justify-end pe-2 text-neutral-700 opacity-30 transition-colors transition-opacity after:pointer-events-none after:absolute after:right-0 after:top-0 after:z-0 after:h-full after:w-20 after:from-white/100 after:from-15% after:to-white/0 after:to-100% after:opacity-0 after:transition-opacity group-hover/slick:opacity-100 dark:after:from-neutral-900/60 dark:after:to-neutral-800/0"
        >
          <lucide-icon class="z-1" icon="ChevronRight" :size="22" />
        </div>
      </template> -->
    </VueSlickCarousel>
  </div>
</template>

<script>
import LazyImage from '@/components/ui/LazyImage';

import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';

import { mapActions, mapGetters } from 'vuex';

import InteractiveStatic from '@/components/interactive/InteractiveStatic';
export default {
  components: {
    InteractiveStatic,
    VueSlickCarousel,
    LazyImage,
  },
  props: {
    blocks: {
      type: Array,
      required: true,
    },
    sidebar: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      interactive: null,
      imageModalOpen: false,
      sliderSettings: {
        centerMode: false,
        dots: true,
        dotsClass:
          '-mt-4 z-4 relative slick-dots pointer-events-none !flex items-center justify-center  ',
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        swipeToSlide: true,
      },
    };
  },

  computed: {
    ...mapGetters(['sidebarModal']),

    isSidebarModalOpen() {
      return this.sidebarModal?.type === 'image';
    },
  },
  methods: {
    ...mapActions(['OPEN_SIDEBAR_MODAL', 'axiosWrapped']),

    syncSliders(currentPosition, nextPosition) {
      if (this.isSidebarModalOpen) {
        let block = this.blocks[nextPosition];
        if (block.type === 'media') {
          this.OPEN_SIDEBAR_MODAL({
            type: 'image',
            payload: block.data,
            sidebar_id: this.sidebar.id,
          });
        }
      }
    },
    openModal(block) {
      this.OPEN_SIDEBAR_MODAL({
        type: 'image',
        payload: block.data,
        sidebar_id: this.sidebar.id,
      });
    },
  },
};
</script>

<style lang="scss">
@reference "tailwindcss";

.instance-slider-slick .slick-dots {
  --button-color: var(--color-gray-200);
  --button-color-hover: var(--color-gray-300);
  --button-color-active: var(--color-gray-300);
  // & button {
  // @apply ring-2 ring-white/70;
  // }
}

.dark-theme .instance-slider-slick .slick-dots {
  --button-color: var(--color-neutral-700);
  --button-color-hover: var(--color-neutral-600);
  --button-color-active: var(--color-neutral-500);
  // & button {
  // @apply ring-2 ring-neutral-900/50;
  // }
}
.instance-slider-slick {
  & .slick-track {
    @apply flex;

    & .slick-slide {
      @apply h-auto;

      & > div {
        @apply flex h-full;
      }
    }
  }

  & .slick-dots {
    @apply h-4 h-4 gap-1;

    & li {
      @apply pointer-events-auto flex h-4 w-2.5 cursor-pointer items-center transition-[width];

      &:hover,
      &:focus,
      &:active {
        --button-color: var(--button-color-hover);
      }
      &.slick-active {
        @apply w-8;
        --button-color: var(--button-color-active);
      }
      & button {
        @apply pointer-events-none h-1 w-full rounded-lg bg-[var(--button-color)] text-[0px]  transition-colors;
      }
    }
  }
}
</style>
